var _path, _circle, _path2, _path3, _circle2, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLive = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 30,
    viewBox: "0 0 118 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.1719 24V5.81818H36.108V20.0227H43.4588V24H31.1719ZM50.3902 5.81818V24H45.4541V5.81818H50.3902ZM57.7011 5.81818L61.4298 18.6378H61.5718L65.3005 5.81818H70.8758L64.8744 24H58.1272L52.1258 5.81818H57.7011ZM72.627 24V5.81818H85.7306V9.79545H77.563V12.9205H85.0559V16.8977H77.563V20.0227H85.6951V24H72.627Z",
    fill: "#FF0000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97.5,
    cy: 15.5,
    r: 4.5,
    fill: "#FF0000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M104 9L104.315 9.3586C107.525 13.0092 107.387 18.5139 104 22V22",
    stroke: "#FF0000",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108 5L108.511 5.56301C113.823 11.4196 113.598 20.416 108 26V26",
    stroke: "#FF0000",
    strokeWidth: 3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.5,
    cy: 15.5,
    r: 4.5,
    transform: "rotate(180 20.5 15.5)",
    fill: "#FF0000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 22L13.6847 21.6414C10.4754 17.9908 10.6127 12.4861 14 9V9",
    stroke: "#FF0000",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10 26L9.48933 25.437C4.17723 19.5804 4.40202 10.584 10 5V5",
    stroke: "#FF0000",
    strokeWidth: 3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLive);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/live.bf35b9d1.svg";